import axios from 'axios';

let axiosConfig = {
	headers: {
		'Content-Type': 'application/json;charset=UTF-8',
		'Access-Control-Allow-Origin': '*',
	},
};

export default axios.create({
	//baseURL: process.env.VUE_APP_ROOT + '/laravel/public/api/v1',
	axiosConfig,
});
